import React from 'react'
import { Button, Tooltip } from 'components/ui'
import { HiOutlineQuestionMarkCircle } from 'react-icons/hi'
import { useHelp } from 'contexts/HelpContext'

const HelpButton = ({ pageKey, className = '' }) => {
    const { openHelp } = useHelp()

    const handleClick = () => {
        openHelp(pageKey)
    }

    return (
        <Tooltip title="Aide">
            <Button
                variant="plain"
                size="xs"
                className={className}
                icon={<HiOutlineQuestionMarkCircle className="text-xl text-gray-500 hover:text-indigo-600" />}
                onClick={handleClick}
            />
        </Tooltip>
    )
}

export default HelpButton
